import React from 'react';

const icons = [
  {
    id: 1,
    icon: (
      <img
        src={require('../../../../assets/svg/icon-diagnosis.svg').default}
        width="24"
        height="24"
        alt=""
      />
    ),
  },
  {
    id: 19,
    icon: (
      <img
        src={require('../../../../assets/svg/icon-medication.svg').default}
        width="24"
        height="24"
        alt=""
      />
    ),
  },
  {
    id: 17,
    icon: (
      <img
        src={require('../../../../assets/svg/icon-temperature.svg').default}
        width="24"
        height="24"
        alt=""
      />
    ),
  },
  {
    id: 18,
    icon: (
      <img
        src={require('../../../../assets/svg/icon-temperature.svg').default}
        width="24"
        height="24"
        alt=""
      />
    ),
  },
  {
    id: 25,
    icon: (
      <img
        src={require('../../../../assets/svg/icon-find-infection.svg').default}
        width="24"
        height="24"
        alt=""
      />
    ),
  },
  {
    id: 28,
    icon: (
      <img
        src={require('../../../../assets/svg/icon-find-infection.svg').default}
        width="24"
        height="24"
        alt=""
      />
    ),
  },
  {
    id: 15,
    icon: (
      <img
        src={require('../../../../assets/svg/icon-protection.svg').default}
        width="24"
        height="24"
        alt=""
      />
    ),
  },
  {
    id: 10,
    icon: <img src={require('../../../../assets/svg/icon-travel.svg').default} alt="" />,
  },
  {
    id: 16,
    icon: <img src={require('../../../../assets/svg/icon-people.svg').default} alt="" />,
  },
  {
    id: 20,
    icon: <img src={require('../../../../assets/svg/icon-cough.svg').default} alt="" />,
  },
];

export const getIcon = (id: number) => {
  const icon = icons.find((i) => i.id === id);
  return icon ? (
    icon.icon
  ) : (
    <img src={require('../../../../assets/svg/icon-medical-records.svg').default} alt="" />
  );
};
